import { useTranslation } from 'react-i18next';
import { Box, Button, useTheme } from '@mui/material';
import { BackIcon } from '@/components/icons/BackIcon';
import { useGoBack } from '@/hooks/useGoBack';
import { useBreakpoint } from '@/hooks';

interface BackButtonProps {
  label?: string;
  fallback?: string;
  onClick?: () => void;
}

export const BackButton = ({
  label,
  fallback = '/',
  onClick,
}: BackButtonProps) => {
  const { isDesktop } = useBreakpoint();
  const { t } = useTranslation();
  const goBack = useGoBack();
  const theme = useTheme();

  const handleClick = onClick ?? (() => goBack({ fallback }));

  if (isDesktop) return null;

  return (
    <Box>
      <Button
        onClick={handleClick}
        size="medium"
        variant="text"
        data-testid="back-button-card-theme"
        sx={{
          textTransform: 'capitalize',
          color: theme.palette.secondary.main,
          display: 'flex',
          gap: '5px',
        }}
      >
        <BackIcon color={theme.palette.secondary.main} />
        {label ?? t('general.home')}
      </Button>
    </Box>
  );
};

export default BackButton;
